import * as Sentry from '@sentry/react';

export enum StorageKeys {
  IMPERSONATION_EMAIL = 'impersonation_email',
  IMPERSONATION_ID = 'impersonation_id',

  VOA_FANNIE_FREDDIE_POPUP = 'promo_voa_fannie_freddie_popup',
  VOA_FANNIE_FREDDIE_HEADER = 'promo_voa_fannie_freddie_header',

  SUBSCRIPTION_REDIRECT_COUNT = 'subscription_redirect_count',
  SELECTED_PLAN = 'truv_selected_plan',
  SIGNUP_SOURCE = 'truv_signup_source',
  SIGNUP_USE_CASE = 'truv_signup_use_case',

  // Integration
  WORKNUMBER = 'worknumber',
  EXPERIAN = 'experian',
  TRUEWORK = 'truework',
  OCROLUS = 'ocrolus',
  INFORMED = 'informed',
  SIMPLENEXUS = 'simplenexus',
  BANNO = 'banno',
  BLACKKNIGHT = 'blackknight',
  ACCIO = 'accio',
  ENCOMPASS = 'encompass',
  CONSTELLATION = 'constellation',
  TAZWORKS = 'tazworks',
  TWILIO = 'twilio',

  COMMON_FILTERS = 'common_filters',
  ORDER_MANAGER_FILTER = 'order_manager_filter',

  PROMO_MOBILE_DESKTOP_BANNER = 'promo_mobile_desktop_banner',

  LAST_SHOWN_INCIDENT_ID = 'last_shown_incident_id',

  // Upgrade promo (CL-6252)
  UPGRADE_PROMO_STATE = 'upgrade_promo_state',

  // DataGrid
  ORDERS_TABLE_COLUMNS = 'orders_table_columns',
  USERS_TABLE_COLUMNS = 'users_table_columns',
  BILLING_USAGE_TABLE_COLUMNS = 'billing_usage_table_columns',
  TASKS_TABLE_COLUMNS = 'tasks_table_columns',
  TEAM_MEMBERS_TABLE_COLUMNS = 'team_members_table_columns',
  TEMPLATES_TABLE_COLUMNS = 'templates_table_columns',
  LOGS_TABLE_COLUMNS = 'logs_table_columns',
  WEBHOOKS_TABLE_COLUMNS = 'webhooks_table_columns',
}

const handleStorageError = <T>(fn: () => T): T | undefined => {
  try {
    return fn();
  } catch (err) {
    console.error('localStorage error:', err);
    Sentry.captureException(err);

    return undefined;
  }
};

export const createStorageService = (storage: Storage) => ({
  get: (key: StorageKeys) =>
    handleStorageError(() => {
      const value = storage.getItem(key);

      if (!value) {
        return undefined;
      }

      try {
        return JSON.parse(value);
      } catch {
        // If JSON parsing fails, return the raw string value
        return value;
      }
    }),
  set: (key: StorageKeys, value: unknown) => handleStorageError(() => storage.setItem(key, JSON.stringify(value))),
  remove: (key: StorageKeys) => handleStorageError(() => storage.removeItem(key)),
});

export const localStorageService = createStorageService(localStorage);
export const sessionStorageService = createStorageService(sessionStorage);
